/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateSparkEngineInput {
  /**
  * The name of the Spark engine
  */
  'name': string;
  /**
  * The size of the Spark engine
  */
  'engineSize': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineSize",
      "baseName": "engineSize",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateSparkEngineInput.attributeTypeMap;
  }

  public constructor() {
  }
}

